import { typeColors } from '../../constants/tableColumns'

export default function UserTypeDisplay({ userType }) {
  return (
    <span className={`text-sm font-bold  py-1 rounded-md ${typeColors[userType]}`}>
      {userType?.split('_').join(' ')}
    </span>
  )
}
